<ng-container *transloco="let t">
  <ng-container *ngIf="licenses$ | withLoader | async as licenses">
    <div class="py-6" *ngIf="licenses.generalSupport">
      <h3 class="fw-bold mb-4">{{ t('support/manualsAndInstructions') }}</h3>
      <app-video-tutorials [showSection]="true" [licenses]="licenses" [isKindergarten]="isKindergarten()"></app-video-tutorials>

      <!-- Hide video tutorials for now -->
      <!-- <ng-container *ngIf="manualProductsVideo$ | withLoader | async as manualProductsVideo">
        <section class="mt-5" *ngIf="manualProductsVideo.length > 0">
          <h5 class="fw-bold mb-4">{{ t('support/productsVideo') }}</h5>
          <div class="d-flex flex-wrap mb-5 text-center card-wrapper">
            <div *ngFor="let productVideo of manualProductsVideo" class="video-container">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  class="embed-responsive-item"
                  frameborder="0"
                  [src]="productVideo | safe: 'resourceUrl'"
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      </ng-container> -->

      <ng-container *ngIf="manualData$ | withLoader | async as manualsData">
        <section class="mt-5" *ngIf="manualsData.length > 0">
          <h5 class="fw-bold mb-4">{{ t('support/manuals') }}</h5>
          <div class="d-flex flex-wrap mb-5 text-center card-wrapper">
            <ng-container *ngFor="let manualData of manualsData">
              <app-material-single [document]="manualData.documents[0]" [title]="manualData.title"></app-material-single>
            </ng-container>
          </div>
        </section>
      </ng-container>

      <app-video-tutorials
        *ngIf="(licenses.testSupport || licenses.testSupportZ) && (licenses.testSupportVideo || licenses.testSupportVideoZ)"
        [showSection]="false"
      ></app-video-tutorials>

      <div class="manual-footer">
        <h3 class="mb-0 text-center">
          <span class="fw-bold">{{ t('support/youNeedAdvice') }}</span>
          <br />
          <span class="contact">{{ t('support/contactUs') }} <a href="mailto:info@isophi.cz">info&#64;isophi.cz</a></span>
        </h3>
      </div>
    </div>
  </ng-container>
</ng-container>
